/**
 * Italian Number to Words (Handling Elision)
 */
const units = ['zero', 'uno', 'due', 'tre', 'quattro', 'cinque', 'sei', 'sette', 'otto', 'nove'];
const tens = ['', 'dieci', 'venti', 'trenta', 'quaranta', 'cinquanta', 'sessanta', 'settanta', 'ottanta', 'novanta'];

function numberToItalian(n) {
  if (n < 10) return units[n];
  if (n < 20) {
    const teens = ['dieci', 'undici', 'dodici', 'tredici', 'quattordici', 'quindici', 'sedici', 'diciassette', 'diciotto', 'diciannove'];
    return teens[n - 10];
  }
  if (n < 100) {
    const t = Math.floor(n / 10);
    const u = n % 10;
    let tWord = tens[t];
    // Elision: drop final vowel before 'uno' or 'otto'
    if (u === 1 || u === 8) tWord = tWord.slice(0, -1);
    return tWord + (u > 0 ? units[u] : '');
  }
  if (n < 1000) {
    const h = Math.floor(n / 100);
    const r = n % 100;
    let hWord = (h === 1) ? 'cento' : units[h] + 'cento';
    return hWord + (r > 0 ? numberToItalian(r) : '');
  }
  if (n < 1000000) {
    const k = Math.floor(n / 1000);
    const r = n % 1000;
    let kWord = (k === 1) ? 'mille' : numberToItalian(k) + 'mila';
    return kWord + (r > 0 ? numberToItalian(r) : '');
  }
  return n.toString();
}

export const convertToItalian = (num) => {
  const isNegative = num < 0;
  num = Math.abs(num);
  const intPart = Math.floor(num);
  const decPart = Math.round((num - intPart) * 100);
  
  let res = (isNegative ? 'meno ' : '') + numberToItalian(intPart);
  if (decPart > 0) res += ' virgola ' + numberToItalian(decPart);
  return res;
};